import React from "react";

class SearchBar extends React.Component {
  state = { term: "" };

  onInputChange = (event) => {
    this.setState({ term: event.target.value });
  };

  onFormSubmit = (event) => {
    event.preventDefault();

    this.props.onFormSubmit(this.state.term);
  };
  render() {
    return (
      <div className="search-bar ui segment" style={{ background: "#dcdcdc" }}>
        <h2 className="ui header">
          <i className="settings icon"></i>
          <div className="content">
            Ignore Youtube Algorithm
            <div className="sub header">
              
              Only get what you search peacefully
            
            </div>
          </div>
        </h2>
        <form onSubmit={this.onFormSubmit} className="ui form">
          <div className="field"></div>
          {/* <label>Video Search</label> */}
          <input
            type="text"
            value={this.state.term}
            onChange={this.onInputChange}
            placeholder="Search Video"
          />
        </form>
      </div>
    );
  }
}

export default SearchBar;
